/* eslint-disable max-len */
import { SvgProps } from './types'

export const ClipboardIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="53" 
      height="58" 
      viewBox="0 0 53 58" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
    >
      <path d="M32.417 11.1738H40.8008L40.8803 33.5079" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M10.3897 11.1738H2.00586V55.6546H33.093" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.1143 24.8743H30.0478" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.7578 24.8743H12.7749" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.1143 30.5657H30.0478" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.7578 30.5657H12.7749" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.1143 36.2628H30.0478" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.7578 36.2628H12.7749" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M17.1143 41.96H30.0478" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M12.7578 41.96H12.7749" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M27.9128 7.14091H25.9816V5.72088C25.9816 3.26708 23.9935 1.27905 21.5397 1.27905H21.3523C18.836 1.27905 16.8253 3.2898 16.8253 5.772V7.14659H14.894C12.3891 7.14659 10.3613 9.17438 10.3613 11.6793V14.9283H32.4455V11.6793C32.4455 9.17438 30.4177 7.14659 27.9128 7.14659V7.14091Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.5732 5.99926C21.5732 6.09582 21.4937 6.16966 21.4028 6.16966C21.3119 6.16966 21.2324 6.09014 21.2324 5.99926C21.2324 5.90838 21.3119 5.82886 21.4028 5.82886C21.4937 5.82886 21.5732 5.90838 21.5732 5.99926Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M48.9802 40.9319C50.1787 42.4883 50.8887 44.4365 50.8887 46.5552C50.8887 51.6446 46.7593 55.774 41.67 55.774C36.5806 55.774 32.4512 51.6446 32.4512 46.5552C32.4512 41.4659 36.5806 37.3364 41.67 37.3364C42.8912 37.3364 44.0556 37.575 45.1178 38.001" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M36.8301 46.5892L40.596 50.3551L46.509 42.7438" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
